import { IFirmwareConfig } from ".";

export const DR750S_1CH = {
  default: {
    Time: {
      GpsSync: {},
      TimeSet: {},
    },
    Video: {
      ImageSetting: {
        options: [
          { key: "3", value: "Full HD @60fps (Extreme)" },
          { key: "0", value: "Full HD @60fps (Sports)" },
          { key: "1", value: "Full HD @30fps" },
          { key: "2", value: "HD @30fps" },
        ],
      },
      VideoQuality: {
        options: [
          { key: "0", value: "Highest" },
          { key: "1", value: "High" },
          { key: "2", value: "Normal" },
        ],
        options4k: [
          { key: "0", value: "Highest (Extreme)" },
          { key: "0", value: "Highest (Sports)" },
        ],
      },
      NightVision: {
        options: [
          { key: "1", value: "Always" },
          { key: "2", value: "Parking mode only" },
        ],
      },
      FrontBrightness: {},
    },

    Recording: {
      NormalRecord: {},
      AutoParking: {},
      VoiceRecord: {},
      DateDisplay: {},
      SpeedUnit: {},
      UseGpsInfo: {},
      RecordTime: {
        options: [
          {
            key: "1",
            value: "1 min",
          },
          {
            key: "2",
            value: "2 min",
          },
          {
            key: "3",
            value: "3 min",
          },
        ],
        options4k: [
          {
            key: "1",
            value: "1 min (Extreme)",
          },
          {
            key: "1",
            value: "1 min (Sports)",
          },
        ],
      },
      LockEvent: {},
      FrontRotate: {},
    },
    Gsensor: {
      Normal: {},
      Parking: {},
    },
    MotionDetection: {
      MOTIONSENSOR: {},
    },
    System: {
      LED: {
        RECLED: {},
        NORMALLED: {},
        PARKINGLED: {},
        WifiLED: {},
      },
      PSENSOR: {},
      VoiceGuidance: {
        STARTVOICE: {},
        NORMALSTARTVOICE: {},
        EVENTSTARTVOICE: {},
        CHANGERECORDMODEVOICE: {},
        ENDVOICE: {},
        SPEEDALERTVOICE: {},
        PARKINGEVENTVOICE: {},
        CLOUDVOICE: {},
        CHANGECONFIGVOICE: {},
        SHARPTURNVOICE: {},
        HARSHBRAKINGVOICE: {},
        ACCELERATIONVOICE: {},
      },
      VOLUME: {},
      ScheduledReboot: {},
      SpeedAlert: {},
      //BatteryProtection: {},
      UserTextOverlay: {},
    },
    Wifi: {
      LoginCredentials: {},
      WifiSleepMode: {},
      onstart: {},
    },
    Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
    FirmwareLanguage: [
      "English",
      "Japan",
      "China",
      "German",
      "French",
      "Thai",
      "Idn",
      "Vietnam",
      "Spain",
      "Italian",
      "Dutch",
      "Polish",
      "Norwegian",
      "Finnish",
    ],
  } as IFirmwareConfig,
  1.019: {
    System: {
      EventRev: {},
    },
  } as IFirmwareConfig,
};
